import { TmcContextService } from './../../../../common/tmc-context.service';
import { DictionaryKeySelectOption } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { PauseTransportService } from '../../service/pause-transport.service';
import { TranslationService } from '@sdbn/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponseMessage } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { DatePipe } from '@angular/common';
import { AppClientConfigurationService } from '@sdbn/common';

export interface StartTransportPauseDialogData {
  transportId: number;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: any;
  successCallback: () => void;
}

@Component({
  selector: 'app-start-transport-pause-dialog',
  templateUrl: './start-transport-pause-dialog.component.html',
  styleUrls: ['./start-transport-pause-dialog.component.scss']
})
export class StartTransportPauseDialogComponent implements OnInit {

  private datePipe = new DatePipe('de');

  end = null;

  selectedOption: DictionaryKeySelectOption;

  responseMessages: ResponseMessage[];

  note: '';

  constructor(
    public dialogRef: MatDialogRef<StartTransportPauseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StartTransportPauseDialogData,
    private pauseTransportService: PauseTransportService,
    public translationService: TranslationService,
    public cps: AppClientConfigurationService,
    private contextService: TmcContextService) {

    const endDate = new Date();
    const defaultLength = +this.cps.getPropertyValue('visitoverview.pause.default.length.minutes', '30');
    endDate.setMinutes(endDate.getMinutes() + defaultLength);
    this.end = this.datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm', this.contextService.getYard().timezone);
  }

  ngOnInit() { }

  isCancelDisabled() {
    return false;
  }

  cancelDialog() {
    this.dialogRef.close();
  }

  isConfirmDisabled() {
    return false;
  }

  confirm() {

    const endDate = new Date(this.end);

    this.pauseTransportService.startPause({
      cause: this.selectedOption.dictionaryKey,
      plannedEnd: this.datePipe.transform(endDate, 'dd.MM.yyyy HH:mm', this.contextService.getYard().timezone),
      transport: { id: this.data.transportId },
      note: this.note
    }).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.data.successCallback();
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.error(error);
    });
  }

  optionsChanged(event: DictionaryKeySelectOption) {
    this.selectedOption = event;
  }

}
